export default __webpack_public_path__ + "static/media/suit-2.d4dec1d4.jpg";